<app-expandable-section-box
  [title]="'Internal Information'"
  [iconClass]="'icon-list-alt'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col flex-1 py-3" expandedContent>
    <div class="space-y-5 divide-y-2">
      <div
        class="space-y-2"
        *ngIf="urls?.length > 0; else emptyURLArrayMessage"
      >
        <span>Live url(s):</span>
        <div class="divide-y-2">
          <p
            class="px-2 py-2 break-word hover:bg-opacity-50 hover:bg-project-2100"
            *ngFor="let liveUrl of urls"
          >
            {{ liveUrl.url }}
          </p>
        </div>
      </div>
      <ng-template #emptyURLArrayMessage>
        <p>No urls available</p>
      </ng-template>
      <div class="space-y-2" *ngIf="contentId; else emptyIdsArrayMessage">
        <div
          class="flex justify-between py-1 hover:bg-opacity-50 hover:bg-project-2100"
        >
          <span>Content Id: </span>
          <span>{{ contentId }}</span>
        </div>
      </div>
      <ng-template #emptyIdsArrayMessage>
        <p class="pt-4">No Content Id available</p>
      </ng-template>
    </div>
  </div>
</app-expandable-section-box>
